import { CustomDataGrid } from '../../components/CustomDataGrid';
import { withLoadingAndOverlay } from '../../hoc';

function FeatureTaxonomyTable({
  selectedView, count, data, columns, page, setPage, pageSize, setPageSize,
}) {
  return (
    <CustomDataGrid
      footer
      rowId="id"
      columnHeaderHeight={72}
      columns={columns}
      rows={data}
      {...(selectedView === 0 ? {
        pagination: true,
        paginationMode: 'server',
        rowCount: count,
        page,
        pageSize,
        onPageChange: (newPage) => setPage(newPage),
        onPageSizeChange: (newSize) => {
          setPageSize(newSize);
          setPage(0);
        },
      } : {
        rowsPerPageOptions: [10],
        pageSize: 10,
      })}
    />
  );
}

export default withLoadingAndOverlay(FeatureTaxonomyTable);
